import searchBar from '@/globals/searchBar'
import pagination from '@/globals/pagination'
import tableList from '@/globals/tableList'
import utils from '@/mixins/utils'
import client from '@/mixins/client'

let paginationUtils = {
  mixins: [utils, client],
  components: {
    searchBar,
    pagination,
    tableList
  },
  data: function () {
    return {
      action: '',
      limit: false,
      params: null,
      data: {},
      loading: false,
      searchValue: '',
      sort: null,
      page: 1,
      start: 0,
      end: 0,
      total: 0,
      next: 1,
      prev: null,
      tableData: []
    }
  },
  methods: {
    changeDateRange: function (e) {
      this.dateRange = e.target.value
      this.getData()
    },
    paginate: function (page) {
      this.page = page
      this.addParamsToLocation({
        s: this.searchValue,
        sort: this.sort,
        page: this.page
      })
      this.loading = true

      if (this.$route.name === 'vendorsList') {
        this.request('get', '/vendors/recalculate-totals/?shop_id=' + this.$store.state.shop.id + '&page=' + this.page).then(response => {
          this.getData()
        })
      } else {
        this.getData()
      }
    },
    orderBy: function (sort) {
      this.sort = sort
      this.page = 1
      this.addParamsToLocation({
        s: this.searchValue,
        sort: this.sort,
        page: this.page
      })
      this.getData()
    },
    search: function (search) {
      this.loading = true
      this.searchValue = search
      this.page = 1
      this.addParamsToLocation({
        s: this.searchValue,
        sort: this.sort,
        page: this.page
      })
      this.getData()
    },
    getData () {
      this.loading = true
      this.tableHeader.currentSort = this.sort

      let data = {
        ordering: this.sort,
        page: this.page,
        search: this.searchValue,
        page_size: this.limit
      }

      if (this.params !== null) {
        for (let key in this.params) {
          data[key] = this.params[key]
        }
      }

      this.request('get', this.action, data).then(response => {
        if (response.results !== undefined) {
          let results = response.results
          this.total = response.count
          this.prev = response.previous
          this.next = response.next
          this.tableData = []
          if (this.total !== 0) {
            this.start = (50 * this.page) - 50 + 1
          } else {
            this.start = 0
          }
          this.end = (50 * this.page) - 50 + results.length
          this.data = results
        } else {
          this.data = response
        }

        this.loading = false

        this.buildTable()
      })
    },
    buildTable () {},
    callback (method, args = []) {
      this[method](...args)
    }
  },
  created () {
    if (this.$route.query.s) {
      this.searchValue = this.$route.query.s
    }

    if (this.$route.query.page) {
      this.page = this.$route.query.page
    }

    if (this.$route.query.sort) {
      this.sort = this.$route.query.sort
    }
  }
}

export default paginationUtils



// WEBPACK FOOTER //
// ./src/mixins/paginationUtils.js